import api from "@/utils/axios";

const ORDER_API_URL = `/orders`;

export default {
  namespaced: true,
  state: {
    orders: [],
    order: null,
    meta: {},
    loading: false,
    error: null,
  },
  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    APPEND_ORDERS(state, orders) {
      state.orders = [...state.orders, ...orders];
    },
    SET_ORDER(state, order) {
      state.order = { ...order };
    },
    SET_META(state, meta) {
      state.meta = meta;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ORDER(state) {
      state.order = null;
      state.error = null;
    },
    CLEAR_ORDERS(state) {
      (state.orders = []), (state.meta = {}), (state.error = null);
    },
  },
  actions: {
    async fetchOrder({ commit }, orderId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.get(`${ORDER_API_URL}/${orderId}/`);
        commit("SET_ORDER", res.data);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to fetch order"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchCart({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.get(`${ORDER_API_URL}/cart/`);
        commit("SET_ORDER", res.data);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to fetch order"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createOrder({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${ORDER_API_URL}/`, payload);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Order creation failed"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateOrder({ commit }, { id, payload }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.patch(`${ORDER_API_URL}/${id}/`, payload);
        commit("SET_ORDER", res.data);
        return res.data;
      } catch (err) {
        commit("SET_ERROR", err.response?.data?.error || "Order update failed");
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteOrder({ commit }, orderId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.delete(`${ORDER_API_URL}/${orderId}/`, {
          successNotify: true,
          errorNotify: true,
        });
        return true;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Order deletion failed"
        );
        return false;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async lazyLoadOrders({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${ORDER_API_URL}/filter/`, payload);
        commit("APPEND_ORDERS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to fetch orders"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async filterOrders({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${ORDER_API_URL}/filter/`, payload);
        commit("SET_ORDERS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to fetch orders"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    clearOrder({ commit }) {
      commit("CLEAR_ORDER");
    },

    clearOrders({ commit }) {
      commit("CLEAR_ORDERS");
    },
  },
  getters: {
    orders: (state) => state.orders,
    order: (state) => state.order,
    ordersMeta: (state) => state.meta,
    isOrderLoading: (state) => state.loading,
    orderError: (state) => state.error,
  },
};
